import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';

const GlobalStyles = createGlobalStyle`
  ${reset};

  input {
    // Remove IOS Default Style 
    -webkit-appearance: none;
    -webkit-border-radius: 0;
  }

  html, body, #root {
    font-family: ${(props) => props.theme.fonts.body};
    touch-action: manipulation;
  }
  
  html {
    /* overflow: hidden; */
  }
  
  #root {
    min-height: 100vh;
    background-color: #f4f4f4;
    padding-bottom: ${({ theme }) => theme.config.navigationHeight};
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  .modal{
    padding-left: 0 !important;

    .modal-body{
      overflow-y: hidden;
    }
  }

  .max-w-400{
    max-width: 400px;
  }

  .min-w-300{
    min-width: 300px;
  }

  .material-symbols-outlined {
    font-variation-settings:
    'FILL' 0,
    'wght' 300,
    'GRAD' 0,
    'opsz' 24
  }
`;

export default GlobalStyles;
